import { Crud } from "@/api";
import { timed } from "@/utils/loaderLogger";
import {
  ShippingMethod,
  ShippingStatus,
  WorkList,
  WorkListGroup,
  WorkListStatus,
  WorklistColumn,
} from "@/utils/types/types";

export type MasterlistData = {
  worklists: WorkList[];
  worklistGroups: WorkListGroup[];
  worklistStatuses: WorkListStatus[];
  worklistColumns: WorklistColumn[];
  shippingMethods: ShippingMethod[];
  shippingStatuses: ShippingStatus[];
};

export default function dashboardMasterlistLoader() {
  const data: Promise<MasterlistData> = Promise.all([
    timed("worklistGroups.getAll", Crud.worklistGroups.getAll()),
    timed("worklistStatuses.getAll", Crud.worklistStatuses.getAll()),
    timed("worklistColumns.getAll", Crud.worklistColumns.getAll()),
    timed("shippingMethods.getAll", Crud.shippingMethods.getAll()),
    timed("shippingStatuses.getAll", Crud.shippingStatuses.getAll()),
  ]).then(
    async ([
      worklistGroups,
      worklistStatuses,
      worklistColumns,
      shippingMethods,
      shippingStatuses,
    ]) => {
      const regularGroupIds = worklistGroups
        .filter(g => !g.isOwnPage)
        .map(g => g.id);

      const worklists =
        regularGroupIds.length > 0
          ? await timed(
              "worklists.getAll(regularGroups)",
              Crud.worklists.getAll({
                workListGroupId: { in: regularGroupIds } as any,
              })
            )
          : [];

      return {
        worklists,
        worklistGroups,
        worklistStatuses,
        worklistColumns,
        shippingMethods,
        shippingStatuses,
      };
    }
  );

  return { data };
}
